import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";
import DiscreetBar from "./DiscreetBar";
import SplashScreen from "./SplashScreen";

export function usePublicTheme() {
  useEffect(() => {
    document.documentElement.classList.remove("admin-theme");
    document.documentElement.classList.add("dark");
  }, []);
}

export default function PublicLayout() {
  usePublicTheme();
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);
  return (
    <div className="min-h-screen bg-lux-bg text-lux-text">
      <PublicHeader />
      <main id="main" tabIndex={-1} className="outline-none">
        <Outlet />
      </main>
      <PublicFooter />
      <DiscreetBar />
      <SplashScreen />
    </div>
  );
}
